import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Form,
} from "reactstrap";
import { NoticiaService } from "service/NoticiaService";
import FSelect from "components/Select/FSelect";

const noticiaService = new NoticiaService();

const ModalNoticia = ({ isOpen, toggle, selectedNoticia, onSave }) => {
  const [noticia, setNoticia] = useState({
    denominacion: "",
    descripcion: "",
    estado: "Activo",
  });

  useEffect(() => {
    if (isOpen) {
      if (selectedNoticia) {
        setNoticia(selectedNoticia);
      } else {
        setNoticia({ denominacion: "", descripcion: "", estado: "Activo" });
      }
    }
  }, [isOpen, selectedNoticia]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNoticia((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!noticia.denominacion.trim()) {
      alert("El título es obligatorio");
      return;
    }
    try {
      let res;
      if (noticia._id) {
        res = await noticiaService.updateNoticia(noticia);
      } else {
        res = await noticiaService.addNoticia(noticia);
      }
      if (res?.confirmation === "success") {
        alert(noticia._id ? "Noticia actualizada" : "Noticia registrada");
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al procesar la solicitud");
      }
    } catch (error) {
      console.error("Error guardando noticia:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>
        {noticia._id ? "Editar Noticia" : "Nueva Noticia"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>Título</Label>
            <Input
              name="denominacion"
              value={noticia.denominacion}
              onChange={handleChange}
              placeholder="Título de la noticia"
            />
          </FormGroup>
          <FormGroup>
            <Label>Descripción</Label>
            <Input
              type="textarea"
              name="descripcion"
              value={noticia.descripcion}
              onChange={handleChange}
              placeholder="Descripción de la noticia"
              rows="4"
            />
          </FormGroup>
          <FormGroup>
            <Label>Estado</Label>
            <FSelect
              name="estado"
              value={noticia.estado}
              onChange={handleChange}
              options={[
                { value: "Activo", label: "Activo" },
                { value: "Inactivo", label: "Inactivo" },
              ]}
            />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleSave}>
          Guardar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalNoticia;
